/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface ISecurityRequirementParent {
    /**
     * Returns a list of all security requirements.
     * @return {SecurityRequirement[]}
     */
    getSecurityRequirements() : Array<SecurityRequirement>;

    /**
     * Creates an OAS Security Requirement object.
     * @return {SecurityRequirement}
     */
    createSecurityRequirement() : SecurityRequirement;

    /**
     * Adds a security requirement child.
     * @param {SecurityRequirement} securityRequirement
     * @return {SecurityRequirement}
     */
    addSecurityRequirement(securityRequirement : SecurityRequirement) : SecurityRequirement;
}



import { SecurityRequirement } from './SecurityRequirement';

